<template>
  <div>
    <h4>{{ data.title }}</h4>

    <div class="mb-4" v-if="data.description">
      <h6 class="my-3">Вопрос:</h6>
      <RichEditor
        v-model="data.description"
        @focus="focus($event)"
      />
    </div>

    <div v-if="data.answers.length">
      <h6 class="my-2">Ответы:</h6>
      <ul>
        <li v-for="(answer, k) in data.answers" :key="k">
          <div :class="`questions-test ${answer.is_true ? 'true' : ''}`">
            <div v-if="answer['img']" class="questions-test-img">
              <img :src="answer['img']"/>
            </div>
            <div class="questions-test-title">
              <h6>{{ k + 1 }}. {{ answer["title"] }}</h6>
              <!-- <p>{{ answer["description"] }}</p> -->
              <span v-if="answer.is_true" class="badge badge-success"
              >Правильный</span
              >
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import RichEditor from "@/components/Editor/RichTextEditor.vue";

export default {
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [],
        },
        readOnly: true,
        theme: "snow",
      },
    };
  },
  props: ["data"],
  components: {
    RichEditor,
  },
  methods: {
    focus(event) {
      event.enable(false);
    },
  },
};
</script>
